import { AfterViewInit, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { UserPreferences } from 'src/app/user-management/models/user-preferences.model';
import { User } from 'src/app/user-management/models/user.model';
import { MaterialInputAppearance } from '../models/generic-resource-model';
import { AuthService } from './auth.service';

declare const $: any;
const md: any = {
  misc: {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
  }
};

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {

  // Base/dark hex pair per accent key, matches the swatches in navbar.component.ts
  private static readonly ACCENT_COLOR_MAP: { [key: string]: { base: string; dark: string } } = {
    purple: { base: '#10b981', dark: '#059669' },
    azure: { base: '#2CA8FF', dark: '#0277bd' },
    green: { base: '#4caf50', dark: '#1b5e20' },
    orange: { base: '#ff9800', dark: '#e65100' },
    danger: { base: '#f44336', dark: '#b71c1c' },
    rose: { base: '#e91e63', dark: '#880e4f' },
  };

  defaultUserPreferences: UserPreferences = new UserPreferences({
    id: 0,
    imageName: "./assets/img/sidebar-1.jpg",
    //sideBarBackgroundColor: "azure",
    sideBarBackgroundColor: "white",
    sideBarFilterColor: "purple",
    sideBarImageEnabled: false,
    sideBarMiniEnabled: false,
  });

  private _selectionColor: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundColor: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundImage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private _backgroundImageEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _sideBarMiniEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  private _inputAppearance: BehaviorSubject<MaterialInputAppearance> = new BehaviorSubject<MaterialInputAppearance>(null);
  private _darkModeEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _surfaceTone: BehaviorSubject<string> = new BehaviorSubject<string>("slate");
  private _languague: string = "en";

  constructor(private translateService: TranslateService, private authService: AuthService) {
    // let userPreferences: UserPreferences = this.currentUserPreferencesValue;
    // this.authService.currentUserSubs.subscribe()
    // let useDefaultSettings: boolean = userPreferences == null;
    // this._selectionColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarFilterColor : userPreferences.sideBarFilterColor);
    // this._backgroundColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarBackgroundColor : userPreferences.sideBarBackgroundColor);
    // this._backgroundImage.next(useDefaultSettings? this.defaultUserPreferences.imageName : userPreferences.imageName);
    // this._backgroundImageEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarImageEnabled : userPreferences.sideBarImageEnabled);
    // this._sideBarMiniEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarMiniEnabled : userPreferences.sideBarMiniEnabled);
    // this._inputAppearance.next(localStorage.getItem('matInputAppearance') as MaterialInputAppearance);
    this._languague = localStorage.getItem('languageSetting');

    if (this._languague) {
      this.translateService.use(this._languague);
    }

    const darkModeSetting = localStorage.getItem('darkModeEnabled') === 'true';
    this._darkModeEnabled.next(darkModeSetting);
    this.updateDarkModeUI(darkModeSetting);

    const surfaceToneSetting = localStorage.getItem('surfaceTone') || "slate";
    this._surfaceTone.next(surfaceToneSetting);
    this.updateSurfaceToneUI(surfaceToneSetting);

    const accentSetting = localStorage.getItem('selectionColor');
    if (accentSetting) {
      this._selectionColor.next(accentSetting);
      this.updateSelectionColorUI(accentSetting);
    }
  }

  public reloadUserPreferences() {
    let userPreferences: UserPreferences = this.currentUserPreferencesValue;
    let useDefaultSettings: boolean = userPreferences == null || userPreferences == undefined;
    // A locally chosen accent takes precedence over the backend default so it survives a refresh
    const storedAccent = localStorage.getItem('selectionColor');
    this._selectionColor.next(storedAccent ? storedAccent : (useDefaultSettings? this.defaultUserPreferences.sideBarFilterColor : userPreferences.sideBarFilterColor));
    this._backgroundColor.next(useDefaultSettings? this.defaultUserPreferences.sideBarBackgroundColor : userPreferences.sideBarBackgroundColor);
    this._backgroundImage.next(useDefaultSettings? this.defaultUserPreferences.imageName : userPreferences.imageName);
    this._backgroundImageEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarImageEnabled : userPreferences.sideBarImageEnabled);
    this._sideBarMiniEnabled.next(useDefaultSettings? this.defaultUserPreferences.sideBarMiniEnabled : userPreferences.sideBarMiniEnabled);
    this.applyPreferences();
  }

  public applyPreferences() {
    if (this._selectionColor.value) {
      this.updateSelectionColorUI(this._selectionColor.value);
    }
    if (this._backgroundColor.value) {
      this.updateBackgroundColorUI(this._backgroundColor.value);
    }
    if (this._backgroundImage.value) {
      this.updateBackgroundImageUI(this._backgroundImage.value);
    }
    // if (this._backgroundImageEnabled.value) {
    //   this.updateBackgroundImageEnabled(this._backgroundImageEnabled.value);
    // }
    if (this._sideBarMiniEnabled.value) {
      this.updateSidebarMiniEnabled(this._sideBarMiniEnabled.value);
    }
  }

  public changeLanguage(lang: string | undefined) {
    if (!lang) {
      return;
    }
    this._languague = lang;
    localStorage.setItem('languageSetting', lang);
    this.translateService.use(lang);
  }

  public updateBackgroundImageUI(image: string) {

    let $sidebar = $('.sidebar');
    let $sidebar_img_container = $sidebar.find('.sidebar-background');
    let $sidebar_responsive = $('body > .navbar-collapse');
    let $full_page_background = $('.full-page-background');

    if ($sidebar_img_container.length !== 0 && this._backgroundImageEnabled.value == true) {
      $sidebar_img_container.fadeOut('fast', function () {
        $sidebar_img_container.css('background-image', 'url("' + image + '")');
        $sidebar_img_container.fadeIn('fast');
      });
    }

    if ($full_page_background.length !== 0 && this._backgroundImageEnabled.value == true) {
      // let new_image_full_page = $('.fixed-plugin li.active .img-holder').find('img').data('src');
      // if (new_image_full_page == undefined){
      //   new_image_full_page = image;
      // }
      $full_page_background.fadeOut('fast', function () {
        $full_page_background.css('background-image', 'url("' + image + '")');
        $full_page_background.fadeIn('fast');
      });
    }

    if (this._backgroundImageEnabled.value == true) {
      // let image2 = $('.fixed-plugin li.active .img-holder').find('img').attr('src');
      // let new_image_full_page = $('.fixed-plugin li.active .img-holder').find('img').data('src');
      // if (new_image_full_page == undefined || image2 == undefined){
      //   new_image_full_page = image;
      // }
      $sidebar_img_container.css('background-image', 'url("' + image + '")');
      $full_page_background.css('background-image', 'url("' + image + '")');
    }

    if ($sidebar_responsive.length !== 0) {
      $sidebar_responsive.css('background-image', 'url("' + image + '")');
    }
  }

  public updateBackgroundColorUI(color: string) {
    let $sidebar = $('.sidebar');
    if ($sidebar.length !== 0) {
      $sidebar.attr('data-background-color', color);
    }
  }

  public updateSelectionColorUI(color: string) {

    let $sidebar = $('.sidebar');
    let $full_page = $('.full-page');
    let $sidebar_responsive = $('body > .navbar-collapse');

    if ($sidebar.length !== 0) {
      $sidebar.attr('data-color', color);
    }

    if ($full_page.length !== 0) {
      $full_page.attr('filter-color', color);
    }

    if ($sidebar_responsive.length !== 0) {
      $sidebar_responsive.attr('data-color', color);
    }

    const accent = UserPreferencesService.ACCENT_COLOR_MAP[color];
    const body = document.getElementsByTagName('body')[0];
    if (body && accent) {
      body.style.setProperty('--theme-accent', accent.base);
      body.style.setProperty('--theme-accent-dark', accent.dark);
    }
  }

  public updateBackgroundImageEnabled(value: boolean) {

  }

  public updateDarkModeUI(enabled: boolean) {
    const body = document.getElementsByTagName('body')[0];
    if (!body) {
      return;
    }
    body.classList.toggle('dark-mode', enabled);
  }

  public updateSurfaceToneUI(tone: string) {
    const body = document.getElementsByTagName('body')[0];
    if (!body) {
      return;
    }
    body.setAttribute('data-surface', tone);
  }

  public updateSidebarMiniEnabled(value: boolean) {
    if (value == false) {
      $('body').removeClass('sidebar-mini');
      md.misc.sidebar_mini_active = false;
    }

    if (value == true) {
      setTimeout(function () {
        $('body').addClass('sidebar-mini');
        $('.sidebar .collapse').css('height', 'auto');
        md.misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  public get currentUserPreferencesValue(): UserPreferences | null {
    return this.authService.currentUserValue?.preferences;
  }

  public set currentUserPreferencesValue(preferences: UserPreferences) {
    if (preferences == null) {
      return;
    }
    let user: User = this.authService.currentUserValue;
    if (!user) return;
    user.preferences = preferences;
    this.authService.currentUserValue = user;
  }

  get language() {
    return this._languague;
  }

  // Single source of truth for the accent swatches shown in the navbar
  get accentColors(): { key: string; hex: string }[] {
    return Object.keys(UserPreferencesService.ACCENT_COLOR_MAP).map((key) => ({
      key,
      hex: UserPreferencesService.ACCENT_COLOR_MAP[key].base,
    }));
  }

  get selectionColor() {
    return this._selectionColor.value;
  }

  get selectionColorBehavior() {
    return this._selectionColor;
  }

  set selectionColor(color: string) {
    if (!color) {
      return;
    }

    this.updateSelectionColorUI(color);
    localStorage.setItem('selectionColor', color);
    this._selectionColor.next(color);
  }

  get backgroundColor() {
    return this._backgroundColor.value;
  }

  set backgroundColor(color: string) {
    if (!color) {
      return;
    }

    this.updateBackgroundColorUI(color);
    // localStorage.setItem('bgColor', color);
    this._backgroundColor.next(color);
  }

  get backgroundImage() {
    return this._backgroundImage.value;
  }

  set backgroundImage(image: string) {
    if (!image) {
      return;
    }
    this.updateBackgroundImageUI(image);
    // localStorage.setItem('bgImage', image);
    this._backgroundImage.next(image);
  }

  get backgroundImageEnabled() {
    return this._backgroundImageEnabled.value;
  }

  get backgroundImageEnabledBehavior() {
    return this._backgroundImageEnabled;
  }

  set backgroundImageEnabled(value: boolean) {
    // let valueBoolean = JSON.stringify(value)
    this.updateBackgroundImageEnabled(value);
    // localStorage.setItem('bgImageEnabled', valueBoolean);
    this._backgroundImageEnabled.next(value);
  }

  get sideBarMiniEnabled() {
    return this._sideBarMiniEnabled.value;
  }

  set sideBarMiniEnabled(value: boolean) {
    // let valueBoolean = JSON.stringify(value)
    this.updateSidebarMiniEnabled(value);
    // localStorage.setItem('sideBarMiniEnabled', valueBoolean);
    this._sideBarMiniEnabled.next(value);
  }

  get inputAppearance() {
    return this._inputAppearance.value;
  }

  get inputAppearanceBehavior() {
    return this._inputAppearance;
  }

  set inputAppearance(type: MaterialInputAppearance) {
    if (!type) {
      return;
    }

    this._inputAppearance.next(type);
  }

  get darkModeEnabled() {
    return this._darkModeEnabled.value;
  }

  get darkModeEnabledBehavior() {
    return this._darkModeEnabled;
  }

  set darkModeEnabled(value: boolean) {
    this.updateDarkModeUI(value);
    localStorage.setItem('darkModeEnabled', String(value));
    this._darkModeEnabled.next(value);
  }

  get surfaceTone() {
    return this._surfaceTone.value;
  }

  get surfaceToneBehavior() {
    return this._surfaceTone;
  }

  set surfaceTone(tone: string) {
    if (!tone) {
      return;
    }
    this.updateSurfaceToneUI(tone);
    localStorage.setItem('surfaceTone', tone);
    this._surfaceTone.next(tone);
  }
}
